import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DownloadPdfComponent } from './download-pdf.component';


const routes: Routes = [
  {
    path: '',
    component: DownloadPdfComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DownloadPdfRoutingModule { }
